import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.scss';
import Home from './pages/Home';
import reportWebVitals from './reportWebVitals';
import {QueryClient, QueryClientProvider} from "@tanstack/react-query";
import AppLayout from "./layouts/AppLayout";
import {BrowserRouter, Navigate, Route, Routes} from "react-router";
import {ScoreList} from "./components/ScoreList";
import {Register} from "./components/Register";
import {Login} from "./components/Login";
import AuthLayout from "./layouts/AuthLayout";
import RequireAuth from "./components/RequireAuth";


const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

const queryClient = new QueryClient()

root.render(
    <React.StrictMode>
        <QueryClientProvider client={queryClient}>
            <BrowserRouter>
                <Routes>
                    {/* AuthLayout routes */}
                    <Route path="/auth" element={<AuthLayout/>}>
                        <Route index element={<Navigate to="/auth/login" replace/>}/>
                        <Route path="login" element={<Login/>}/>
                        <Route path="register" element={<Register/>}/>
                    </Route>

                    {/* Protected routes */}
                    <Route path="/" element={<RequireAuth><AppLayout/></RequireAuth>}>
                        <Route index element={<Home/>}/>
                        <Route path="category/:category" element={<ScoreList/>}/>
                    </Route>

                    {/* Fallback */}
                    <Route path="*" element={<Navigate to="/"/>}/>
                </Routes>
            </BrowserRouter>
        </QueryClientProvider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
